// extracted by mini-css-extract-plugin
export var headerAndSubheader = "headerAndSubheader-module--header-and-subheader--DCcxT";